export function formatCnpj(value) {
  const normalized = (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const rootAndBranch = normalized.substring(0, 12);
  const checkDigits = normalized
    .substring(12)
    .replace(/\D/g, '')
    .substring(0, 2);
  const caracteres = rootAndBranch + checkDigits;

  return caracteres
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
    .replace(/([A-Z0-9]{4})([A-Z0-9])/, '$1-$2');
}
